import * as yup from 'yup';

const schema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required(),
});

export default schema;
